export const get_parsed_likefollow_array = (likefollowArray) => {
  return likefollowArray.map((list_info)=>{
    const splitInfo = list_info.split(",")
    const id = splitInfo[0]
    const name = splitInfo[1]
    const screen_name = splitInfo[2]
    const profile_image_url = splitInfo[3]
    return {id, screen_name, name, profile_image_url}
  })
}


export const add_user_to_likefollow_array = (listsArray, userinfo) => {
  let listsArrayCopy = [...listsArray]
  const listInfo = `${userinfo.id},${userinfo.name},${userinfo.screen_name},${userinfo.profile_image_url}`
  const idIdx = listsArrayCopy.findIndex(elm => elm.split(",")[0] == userinfo.id)
  if(idIdx >= 0) listsArrayCopy[idIdx] = listInfo
  else listsArrayCopy.push(listInfo)
  return listsArrayCopy
}
